import React, { PureComponent } from 'react';

import { fixImageSrc } from './Image';

const ImageRenderer = ({ show, src, className, ...restProps }) => (
  <div
    css={`
      position: absolute;
      width: 100%;
      height: 100%;
      transition: opacity 0.5s 0.25s;
      background: ${src} center center / cover no-repeat;

      opacity: ${show ? 1 : 0};

      ${className};
    `}
    {...restProps}
  />
);

export class PreviewImage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    const { clientWidth: width, clientHeight: height } = this.container;
    const { src, cloudinaryOptions } = this.props;
    let fixedSrc;
    if (typeof src === 'function') {
      fixedSrc = src(width, height);
    } else {
      fixedSrc = fixImageSrc(
        src,
        {
          width,
          height,
          cover: true,
        },
        cloudinaryOptions
      );
    }

    this.setState({ fixedSrc });

    if (Image) {
      // eslint-disable-next-line no-undef
      const imgLoader = new Image();
      imgLoader.onload = () => this.setState({ loaded: true });
      imgLoader.src = fixedSrc;
    }
  }

  render() {
    const { preview, aspectRatio, alt, width, height, className } = this.props;
    const { fixedSrc } = this.state;

    return (
      <div
        ref={container => (this.container = container)}
        css={`
          position: relative;
          width: ${width};
          ${height
            ? `height: ${height}`
            : `padding-bottom: ${1 / aspectRatio * 100}%`};
        `}
      >
        <ImageRenderer
          src={preview}
          className={className}
          alt={alt}
          show={this.state.loaded === false}
        />
        <ImageRenderer
          src={`url("${fixedSrc}")`}
          className={className}
          aria-label={alt}
          show={this.state.loaded}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/PreviewImage.js